// src/lib/utils.ts
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format duration in seconds to human-readable format
 * Examples:
 * - 45 seconds -> "45s"
 * - 90 seconds -> "1m 30s"
 * - 3600 seconds -> "1h 0m"
 * - 3665 seconds -> "1h 1m"
 */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || seconds < 0) {
    return 'N/A';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const parts: string[] = [];

  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0 || hours > 0) {
    parts.push(`${minutes}m`);
  }
  if (secs > 0 || parts.length === 0) {
    parts.push(`${secs}s`);
  }

  return parts.join(' ');
}

// Format filter request for persona filtering
export function formatPersonaFilterRequest(
  selectedSegments: number[],
  personaFilters: Record<number, {
    industryL1: string[],
    industryL2: string[],
    functions: string[],
    roles: string[]
  }>
) {
  // Create a properly formatted request object for the filter_personas endpoint
  const filterRequest = {
    segments: selectedSegments,
    filters: Object.entries(personaFilters).reduce((acc, [segmentId, filters]) => {
      // Only include filters for selected segments
      if (selectedSegments.includes(Number(segmentId))) {
        acc[segmentId] = filters;
      }
      return acc;
    }, {} as Record<string, any>)
  };

  return filterRequest;
}
